import { Center } from "@chakra-ui/layout"
import logo from './zigridLogo.jpg'

const Footer = () => {
    return <Center
        py="1.5%"
    >
		<img src={logo}  alt="zigrid logo" height={200} width={200} />
    </Center>
}

export default Footer